import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Icons from 'react-icons/fa';
import './Booking.css';
import ProgressBar from './ProgressBar';

function Booking() {
    const location = useLocation();
    const navigate = useNavigate();

    const [bookingDetails, setBookingDetails] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        country: '',
        zip: '',
        requests: '',
        arrival: 'I do not know',
        coupon: ''
    });

    // Check if room and guests exist in the location state, and set default guests value if not.
    if (!location.state || !location.state.room) {
        navigate('/');
        return null;
    }

    const { room, guests } = location.state; // Now guests are directly received from location.state

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBookingDetails(prevState => ({ ...prevState, [name]: value }));
    };

    const handleBooking = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('http://localhost/hotel-bougainvilla/hotel-admin/backend/save_booking.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...bookingDetails,
                    roomName: room.name,
                    checkIn: room.checkIn,
                    checkOut: room.checkOut,
                    totalPrice: room.totalPrice,
                    guests: guests,
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            if (data.success) {
                navigate('/booking/checkout', {
                    state: {
                        room,
                        guests,
                        bookingDetails
                    }
                });
            } else {
                alert('Booking failed!');
            }
        } catch (error) {
            console.error('Error during booking:', error);
            alert('Booking failed due to a network or server error.');
        }
    };

    const ServiceIcon = ({ iconName }) => {
        const IconComponent = Icons[iconName];
        return IconComponent ? <IconComponent /> : null;
    };

    return (
        <div className="booking-page">
            <ProgressBar currentStep="booking" />
            <div className="custom-booking-page-container">
                <div className="custom-booking-summary">
                    <img src={room.image} alt={room.name} className="custom-room-image" />
                    <div className="custom-booking-summary-details">
                        <h2>Selected Room: {room.name}</h2>
                        <p>Check In: {new Date(room.checkIn).toLocaleDateString()}</p>
                        <p>Check Out: {new Date(room.checkOut).toLocaleDateString()}</p>
                        <p>Nights: {room.nights}</p>
                        <p>Guests: {guests} Adults + 0 Children</p> {/* Display guests data here */}
                        <p>Total Price: ${room.totalPrice.toFixed(2)}</p>
                        <p>18% VAT ALREADY APPLIED</p>
                        <div className="custom-services-container">
                            {room.services.map((service, index) => (
                                <div className="custom-service-item" key={index}>
                                    <ServiceIcon iconName={service.icon} />
                                    <span>{service.text}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="custom-form-container">
                    <form className="custom-booking-form" onSubmit={handleBooking}>
                        <h1>Booking Details</h1>
                        <label className="custom-label custom-field-group"><span className="custom-group-label">Name:</span>
                            <input type="text" name="firstName" value={bookingDetails.firstName} onChange={handleChange} required placeholder="First Name" className="custom-input" />
                            <input type="text" name="lastName" value={bookingDetails.lastName} onChange={handleChange} required placeholder="Surname" className="custom-input" />
                        </label>
                        <label className="custom-label">Email:
                            <input type="email" name="email" value={bookingDetails.email} onChange={handleChange} required placeholder="Email" className="custom-input" />
                        </label>
                        <label className="custom-label">Phone:
                            <input type="text" name="phone" value={bookingDetails.phone} onChange={handleChange} required placeholder="Phone" className="custom-input" />
                        </label>
                        <label className="custom-label custom-address-group"><span className="custom-group-label">Address:</span>
                            <input type="text" name="address" value={bookingDetails.address} onChange={handleChange} placeholder="Address" className="custom-input" />
                            <input type="text" name="city" value={bookingDetails.city} onChange={handleChange} placeholder="City" className="custom-input" />
                            <input type="text" name="country" value={bookingDetails.country} onChange={handleChange} placeholder="Country" className="custom-input" />
                            <input type="text" name="zip" value={bookingDetails.zip} onChange={handleChange} placeholder="ZIP" className="custom-input" />
                        </label>
                        <label className="custom-label">Requests:
                            <textarea name="requests" value={bookingDetails.requests} onChange={handleChange} placeholder="Any special requests?" className="custom-textarea" />
                        </label>
                        <label className="custom-label">Arrival:
                            <select name="arrival" value={bookingDetails.arrival} onChange={handleChange} className="custom-select">
                                <option value="I do not know">I do not know</option>
                                <option value="Morning">Morning</option>
                                <option value="Afternoon">Afternoon</option>
                                <option value="Evening">Evening</option>
                            </select>
                        </label>
                        <label className="custom-terms-label">
                            <input type="checkbox" name="terms" required /> I agree to the <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
                        </label>
                        <button type="submit" className="custom-checkout-button">Proceed to Checkout</button>
                    </form>

                    <button className="custom-go-back-button" onClick={() => navigate(-1)}>Go Back</button>
                </div>
            </div>
        </div>
    );
}

export default Booking;
